export default __webpack_public_path__ + "static/media/2_Our_Team_button.e8215c44.png";